// Mantine
import { Modal, Button } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'

import { notifications } from '@mantine/notifications'

// React
import { useState, useEffect } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Icon
import { Check } from 'tabler-icons-react'

// Dayjs
import dayjs from 'dayjs'

export default function ProductionOrderEditDates({
    opened,
    onClose,
    onChanged,
    ...productionOrder
}) {
    const [startingAt, setStartingAt] = useState(
        dayjs(productionOrder.starting_at).toDate()
    )
    const [endingAt, setEndingAt] = useState(
        dayjs(productionOrder.ending_at).toDate()
    )

    useEffect(() => {
        if (opened) {
            // Parse date-only API values as local calendar dates, never as UTC instants.
            setStartingAt(dayjs(productionOrder.starting_at).toDate())
            setEndingAt(dayjs(productionOrder.ending_at).toDate())
        }
    }, [
        opened,
        productionOrder.id,
        productionOrder.starting_at,
        productionOrder.ending_at,
    ])

    // API
    const { requestPatch, loading } = useAxiosApi()

    const saveDates = async () => {
        if (!isDatesValid) return

        await requestPatch(`/production-orders/${productionOrder.id}`, {
            starting_at: dayjs(startingAt).format('YYYY-MM-DD'),
            ending_at: dayjs(endingAt).format('YYYY-MM-DD'),
        })

        await onChanged()
        onClose()

        notifications.show({
            title: 'Dates modifiées',
            message: 'Les dates ont été modifées.',
            color: 'green',
            icon: <Check size={15} />,
        })
    }

    // Check if the dates are valid
    const isDatesValid = Boolean(
        startingAt && endingAt && !dayjs(endingAt).isBefore(dayjs(startingAt), 'day')
    )

    return (
        <>
            <Modal opened={opened} onClose={onClose} title="Modifier les dates">
                <div className="flex flex-col gap-3">
                    <DatePickerInput
                        label="Dates de début"
                        value={startingAt}
                        onChange={(date) => setStartingAt(date)}
                        locale="fr"
                        valueFormat="LL"
                    />

                    <DatePickerInput
                        label="Dates de fin"
                        value={endingAt}
                        onChange={(date) => setEndingAt(date)}
                        locale="fr"
                        valueFormat="LL"
                    />

                    <Button
                        disabled={!isDatesValid}
                        loading={loading}
                        onClick={saveDates}
                    >
                        Enregistrer les dates
                    </Button>
                </div>
            </Modal>
        </>
    )
}
